import React from 'react';
import { DEFAULT_BOTON_CLASSNAME, DEFAULT_THEME_BUTTON, DARK_THEME_BUTTON } from '../constants/const_tailwind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Boton = ({ ide, texto, onClick, estilo, icono, darkMode, disabled, color, ariaLabel, title, type = 'button' }) => {
    let clasesBoton = estilo;
    if (color) {
        clasesBoton += DEFAULT_BOTON_CLASSNAME + ' ' + color;
    } else {
        clasesBoton += (darkMode && !color ? DARK_THEME_BUTTON : DEFAULT_THEME_BUTTON);
    }
    return (
        <button
            id={ide}
            type={type}
            className={(clasesBoton) + ' disabled:bg-tradewind-300' }
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel}
            title={title}
        >
            {texto}
            {icono && <FontAwesomeIcon icon={icono} />}
        </button>
    );
};

export default Boton;
